var map = {
	"./author.svg": "2825",
	"./bg-img-news-and-announcements-mobile.png": "0fff",
	"./bg-img-news-and-announcements-tablet.png": "0628",
	"./bg-img-news-and-announcements.svg": "e3f5",
	"./bg-img-news-and-announcements3.png": "d043",
	"./bg-news-and-announcements.svg": "11b7",
	"./bg-post-1.png": "b5fc",
	"./bg-post-2.jpg": "83af",
	"./bg-post-3.png": "0514",
	"./bg-post-4.jpg": "fbab",
	"./date-and-time.svg": "7b34",
	"./overlay-bg-archive-news-and-announcements-mobile.png": "babb",
	"./overlay-bg-archive-news-and-announcements-tablet.png": "fcc7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44c7";